/* 🤖 this file was generated by script */
export const wiconUsers01 = {
  name: 'users_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22 21v-2a4 4 0 00-3-3.87M15.5 3.29a4 4 0 010 7.42M17 21c0-1.86 0-2.8-.3-3.53a4 4 0 00-2.17-2.17C13.8 15 12.86 15 11 15H8c-1.86 0-2.8 0-3.53.3a4 4 0 00-2.17 2.17C2 18.2 2 19.14 2 21M13.5 7a4 4 0 11-8 0 4 4 0 018 0z"/></svg>`,
};
